import { SERVICING_ROUTES } from '@conf/routes.config';

/**
 * basic-page-layout l-containerのcolorを変更するURL
 */
export const CHANGE_CONTAINER_COLOR_URLS = [
  `/${SERVICING_ROUTES.seatMap}`,
  `/${SERVICING_ROUTES.informativeSeatmap}`,
] as string[];
